import { type DeviceFragment, DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';

import { DeviceVehicleAssociationStatus, MultiSelectVehicleAssociationType } from '@cobliteam/common-types';
import type { TagProps } from '@cobliteam/ui/components/Tag';
import DeviceStatusTag from '@cobliteam/ui-business/components/Tag/DeviceStatus';
import DeviceTag from '@cobliteam/ui-business/components/Tag/Devices';

import useDevicesStore from '../../../store/useDevicesStore';
import { getDeviceVehicleAssociationStatus } from '../../../utils';

interface DeviceStatusCellProps {
  device: DeviceFragment;
  size?: TagProps['size'];
}

const DeviceStatusCell = ({ device, size = 'md' }: DeviceStatusCellProps) => {
  const { generalStatus } = device;
  const associationStatus = useDevicesStore((state) => state.associationStatus);

  const isAssociated = associationStatus === MultiSelectVehicleAssociationType.ASSOCIATED_TO_VEHICLE;
  const isLosingData = getDeviceVehicleAssociationStatus(device) === DeviceVehicleAssociationStatus.LOSING_DATA;
  const isDevolution = generalStatus === DeviceGeneralStatus.InDevolution;

  if (isDevolution) return <DeviceStatusTag status={generalStatus} showTooltip size={size} />;

  if (isAssociated) return <DeviceStatusTag status={generalStatus} showTooltip size={size} />;

  if (isLosingData) return <DeviceStatusTag status={DeviceGeneralStatus.LosingData} showTooltip size={size} />;

  if (device.isNew) return <DeviceTag.New label='novo dispositivo' size={size} />;

  return <DeviceStatusTag status={generalStatus} showTooltip size={size} />;
};

export default DeviceStatusCell;
